
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34257',
  depVersions: {
  "documents-public-ui": "static-1.34257",
  "client-types": "static-1.457",
  "documents-lib": "static-1.34262",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2032",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5497",
  "hs-test-utils": "static-1.7915",
  "hub-http": "static-1.6122",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11358",
  "I18n": "static-7.1603",
  "jasmine-immutable": "static-1.2920",
  "jasmine-runner": "static-1.6371",
  "lodash": "static-1.3",
  "quartz": "static-1.6873",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16559",
  "reporting-data": "static-1.67044",
  "reporting-testing-lib": "static-1.8977",
  "reporting-visualizations": "static-1.59120",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4672",
  "webpack-env": "static-1.54",
  "atom": "static-1.4974",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2397",
  "classnames": "static-2.10",
  "cssUtils": "static-1.770",
  "customer-data-filters-ui": "static-1.39375",
  "customer-data-objects": "static-1.7562",
  "customer-data-property-utils": "static-1.7987",
  "data-fetching-client": "static-1.9578",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4432",
  "flux-actions": "static-1.325",
  "FormsCommonComponents": "static-1.85583",
  "FormUrlGenerator": "static-2.4622",
  "foundations-components": "static-1.7728",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11666",
  "icons": "static-2.639",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7062",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3755",
  "property-translator": "static-1.5310",
  "quartz-config": "static-1.651",
  "quartz-core": "static-1.6092",
  "quick-fetch": "static-1.3838",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5270",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8070",
  "reference-resolvers-lite": "static-1.7992",
  "report-customization-components": "static-1.12843",
  "reporting-enablement": "static-1.22520",
  "reporting-reports": "static-1.66722",
  "reporting-snowflake": "static-1.55662",
  "reporting-ui-components": "static-2.64315",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4547",
  "sales-content-partitioning": "static-1.8840",
  "SalesContentIndexUI": "static-3.9092",
  "sanitize": "static-1.4376",
  "sanitize-text": "static-1.8048",
  "self-service-api": "static-1.10148",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1653",
  "signup-constants": "static-1.18665",
  "signup-ui-lego-core": "static-1.20675",
  "signup-ui-url-generator": "static-2.7941",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "superstore": "static-1.4672",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10894",
  "ui-addon-i18n": "static-1.11050",
  "ui-addon-react-router-dom": "static-1.9447",
  "ui-addon-upgrades": "static-9.17846",
  "ui-asset-management-lib": "static-1.10886",
  "ui-images": "static-2.1130",
  "UIComponents": "static-3.8305",
  "usage-tracker": "static-1.7238",
  "usage-tracker-container": "static-1.7228",
  "usage-tracker-core": "static-1.7088",
  "usage-tracker-public": "static-1.7049",
  "viral-links-lib": "static-1.6945",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3328",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3150",
  "quartz-webpack": "static-1.3097",
  "ai-components-ui-library": "static-1.8690",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4751",
  "foundations-theming": "static-1.4316",
  "quartz-auth": "static-1.548",
  "ui-business-units-lib": "static-1.8944",
  "usage-tracker-session-replay": "static-1.4924",
  "foundations-theming-base": "static-1.3301",
  "HeadJS": "static-2.735",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3026",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4227",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7827",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3511",
  "persist-promise": "static-1.3612",
  "reporting-client-types": "static-1.2427",
  "foundations-components-legacy": "static-1.753",
  "hs-story-utils": "static-1.9333",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9736",
  "hubspotter-http": "static-1.4574",
  "sassPrefix": "static-1.154",
  "conversations-skeleton-state": "static-1.7154",
  "crm-message-bus": "static-1.42706",
  "customer-data-filters-ui-msw-helpers": "static-1.21810",
  "customer-data-objects-ui-components": "static-1.12922",
  "customer-data-reference-ui-components": "static-1.13057",
  "customer-data-ui-utilities": "static-1.9728",
  "framework-builder-read-service-client": "static-1.3930",
  "framework-data-schema-quick-fetch": "static-1.6683",
  "framework-data-schema-resolvers": "static-1.6778",
  "inbound-db-properties-service-client": "static-1.3767",
  "multi-account-reference-resolvers": "static-1.877",
  "onboarding-tours": "static-1.16421",
  "reporting-datasets-permissions-lib": "static-1.13391",
  "ui-addon-teams": "static-1.21415",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68053",
  "customer-data-properties": "static-1.51198",
  "forms-ai-lib": "static-1.4165",
  "forms-utils-lib": "static-1.12396",
  "foundations-components-test-utils": "static-1.5211",
  "react-dnd-compat": "static-1.4521",
  "react-tinymce": "static-1.54957",
  "tinymce-config": "static-2.54083",
  "ui-gdpr-components": "static-1.10251",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3997",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1540",
  "ui-fonts": "static-1.620",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.819",
  "mobile-manifest-mixins": "static-1.508",
  "module-federation": "static-1.21",
  "quartz-head": "static-1.538",
  "quartz-i18n": "static-1.548",
  "quartz-routing": "static-1.303",
  "quartz-test": "static-1.548",
  "quartz-tracking": "static-1.252",
  "batch-promise": "static-1.1455",
  "external-options-client-types": "static-1.4080",
  "react-colorpicker": "static-2.10112",
  "copilot-toolkit": "static-1.10852",
  "data-quality-ui-library": "static-1.12616",
  "html-to-image": "static-1.52",
  "markdown-it": "static-1.6",
  "onboarding-scopes": "static-1.6367",
  "reporting-action-components": "static-1.40986",
  "reporting-insights-lib": "static-1.1422",
  "reporting-plugins": "static-1.10141",
  "ui-addon-draggable-compat": "static-2.4157",
  "ui-addon-opt": "static-4.8285",
  "ui-shepherd-react": "static-3.10050",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.25068",
  "hubspot-apollo-client": "static-1.4781",
  "chirp-fetch": "static-1.1784",
  "sales-templates-service-types-lib": "static-1.4089",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5690",
  "salesImages": "static-1.523",
  "ts-schema": "static-1.4000",
  "nested-table": "static-1.129",
  "timezone-utils": "static-2.5147",
  "bender-build-tools": "static-1.3063",
  "chatspot-core": "static-1.20824",
  "bend-plugin-foundations-theming": "static-1.2799",
  "stylex": "static-1.30",
  "hubspotter-http-shared-msw-handlers": "static-1.9734",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3719",
  "crm-pipelines-api-client-types": "static-1.4064",
  "multi-currency-client-types": "static-1.3612",
  "getting-started-shared-tasks": "static-1.18215",
  "growth-data-modal": "static-1.5278",
  "growth-onboarding-confetti": "static-1.2974",
  "growth-onboarding-next-action-utils": "static-1.1623",
  "navigation-components": "static-1.17661",
  "onboarding-tours-client": "static-1.4635",
  "onboarding-tours-utils": "static-1.487",
  "ui-shepherd-tracker": "static-1.7431",
  "ui-universal-auth": "static-1.8840",
  "user-context": "static-1.5003",
  "cms-field-types": "static-1.4712",
  "content-icons-ui": "static-1.2203",
  "integrations-lib": "static-1.15795",
  "calling-global-api": "static-1.64114",
  "calling-internal-common": "static-1.31204",
  "calling-lifecycle-internal": "static-1.65496",
  "calling-lifecycle-messages": "static-1.57790",
  "commerce-products-lib": "static-1.9165",
  "crm-links": "static-1.6179",
  "customer-data-properties-shared-msw-handlers": "static-1.9063",
  "file-manager-components": "static-1.23309",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.42",
  "inbounddb-objects-service-types": "static-1.4145",
  "meetings-icalendar-utils-lib": "static-1.533",
  "object-builder-ui-client": "static-1.48406",
  "pipeline-validation-client-types": "static-1.3887",
  "property-value-citations": "static-1.1812",
  "pulse": "static-1.447",
  "smart-property-lib": "static-1.6458",
  "tiered-pricing": "static-1.1017",
  "ui-addon-iframeable": "static-1.8953",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19661",
  "tinymce-themes": "static-1.56053",
  "data-token-picker": "static-1.16232",
  "hub-http-contrib": "static-1.2946",
  "interframe": "static-3.4666",
  "tinymce-data": "static-1.40168",
  "tinymce-plugins": "static-1.57197",
  "ui-addon-sales-email": "static-1.5114",
  "magpie-lib": "static-1.5496",
  "magpie-types": "static-1.4956",
  "simple-logging-lib": "static-1.2954",
  "content-assistance-lib": "static-1.7608",
  "dashboard-lib": "static-1.81113",
  "ExportDialog": "static-6.10293",
  "hubspot-prosemirror": "static-1.17951",
  "hubspot-prosemirror-plugins": "static-1.17943",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8598",
  "campaign-roi-lib": "static-1.8654",
  "feedback-loader": "static-1.29113",
  "apollo-link-hub-http": "static-2.4554",
  "hubspot-apollo-cache": "static-1.240",
  "growth-monetization-service-types": "static-1.4404",
  "nav-client-types": "static-1.2261",
  "purchase-motions-api": "static-1.5693",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.76",
  "onboarding-data-sync-lib": "static-1.1796",
  "growth-onboarding-next-action-components": "static-1.1651",
  "user-context-client": "static-1.4515",
  "idb-keyval": "static-1.42",
  "nest": "static-1.125",
  "reactive-lib": "static-1.627",
  "unified-auth-core-lib": "static-1.635",
  "getting-started-shared-tasks-store": "static-1.17333",
  "integrations-error-boundary-lib": "static-1.13210",
  "integrations-tracking-lib": "static-1.5499",
  "native-integrations-shared-strings": "static-1.7689",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10277",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.354",
  "calling-error-reporting": "static-1.31210",
  "shared-worker-versioning": "static-1.10941",
  "calling-usage-tracker": "static-1.6444",
  "voice-sms-access-library": "static-1.610",
  "customer-data-tracking": "static-1.6787",
  "commerce-permissions": "static-1.668",
  "products-iframe-lib": "static-1.7650",
  "products-ui-components-shared-msw-handlers": "static-1.10118",
  "location-customization-utils-lib": "static-1.8928",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4056",
  "video-components-external": "static-1.10956",
  "video-data-lib": "static-1.34614",
  "directed-graph": "static-1.840",
  "event-emitter": "static-1.851",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.42",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9819",
  "fsm": "static-1.3637",
  "policy-lib": "static-1.6687",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9882",
  "navigation-messaging": "static-1.6988",
  "FileManagerLib": "static-1.38949",
  "NamespacedHubStyle": "static-2.8990",
  "FileManagerCore": "static-1.38808",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12256",
  "layout-dnd-utils": "static-1.11231",
  "react-codemirror": "static-1.10527",
  "ui-addon-emoji-picker": "static-1.9790",
  "ui-brand-identity-lib": "static-1.14802",
  "ui-addon-video-player": "static-1.8599",
  "ui-coaching-tips": "static-1.28264",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8448",
  "payment-link-components": "static-1.23252",
  "EmailSignatureEditor": "static-1.24158",
  "eligibility-engine-service-types": "static-1.3086",
  "InboxConnectUtils": "static-4.14536",
  "universal-page-editor-lib": "static-1.2910",
  "microsoft-drive-integration-lib": "static-1.28",
  "calling-orchestration-schema": "static-1.35387",
  "sales-views-client-types": "static-1.4166",
  "crm-record-cards-service-types": "static-1.3532",
  "content-media-composition-data-lib": "static-1.11923",
  "content-media-compositions": "static-2.15930",
  "media-bridge-lib": "static-1.18752",
  "trellis-story-utils": "static-1.4422",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5770",
  "FileManagerImages": "static-1.36460",
  "video-components": "static-1.12959",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4435",
  "video-embed": "static-1.35448",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68128",
  "layout-data-lib": "static-1.9556",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6485",
  "commerce-tours-lib": "static-1.5914",
  "growth-onboarding-reliability": "static-1.4989",
  "sales-checkout-service-client": "static-1.3569",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21501",
  "sales-email-signature-service-client": "static-1.3746",
  "social-insights-client-types": "static-1.21790",
  "outpost": "static-1.4097",
  "advanced-menus-core": "static-1.14977",
  "advanced-menus-lib": "static-1.11939",
  "ui-memberships-settings-lib": "static-1.33770",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14976",
  "simple-menus-lib": "static-1.16493"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34257",
  "client-types": "/client-types/static-1.457",
  "documents-lib": "/documents-lib/static-1.34262",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2032",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5497",
  "hs-test-utils": "/hs-test-utils/static-1.7915",
  "hub-http": "/hub-http/static-1.6122",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11358",
  "I18n": "/I18n/static-7.1603",
  "jasmine-immutable": "/jasmine-immutable/static-1.2920",
  "jasmine-runner": "/jasmine-runner/static-1.6371",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6873",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16559",
  "reporting-data": "/reporting-data/static-1.67044",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8977",
  "reporting-visualizations": "/reporting-visualizations/static-1.59120",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4672",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4974",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2397",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.770",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39375",
  "customer-data-objects": "/customer-data-objects/static-1.7562",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7987",
  "data-fetching-client": "/data-fetching-client/static-1.9578",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4432",
  "flux-actions": "/flux-actions/static-1.325",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85583",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4622",
  "foundations-components": "/foundations-components/static-1.7728",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11666",
  "icons": "/icons/static-2.639",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7062",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3755",
  "property-translator": "/property-translator/static-1.5310",
  "quartz-config": "/quartz-config/static-1.651",
  "quartz-core": "/quartz-core/static-1.6092",
  "quick-fetch": "/quick-fetch/static-1.3838",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5270",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8070",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7992",
  "report-customization-components": "/report-customization-components/static-1.12843",
  "reporting-enablement": "/reporting-enablement/static-1.22520",
  "reporting-reports": "/reporting-reports/static-1.66722",
  "reporting-snowflake": "/reporting-snowflake/static-1.55662",
  "reporting-ui-components": "/reporting-ui-components/static-2.64315",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4547",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8840",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9092",
  "sanitize": "/sanitize/static-1.4376",
  "sanitize-text": "/sanitize-text/static-1.8048",
  "self-service-api": "/self-service-api/static-1.10148",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1653",
  "signup-constants": "/signup-constants/static-1.18665",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20675",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7941",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "superstore": "/superstore/static-1.4672",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10894",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11050",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9447",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17846",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10886",
  "ui-images": "/ui-images/static-2.1130",
  "UIComponents": "/UIComponents/static-3.8305",
  "usage-tracker": "/usage-tracker/static-1.7238",
  "usage-tracker-container": "/usage-tracker-container/static-1.7228",
  "usage-tracker-core": "/usage-tracker-core/static-1.7088",
  "usage-tracker-public": "/usage-tracker-public/static-1.7049",
  "viral-links-lib": "/viral-links-lib/static-1.6945",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3328",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3150",
  "quartz-webpack": "/quartz-webpack/static-1.3097",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8690",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4751",
  "foundations-theming": "/foundations-theming/static-1.4316",
  "quartz-auth": "/quartz-auth/static-1.548",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8944",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4924",
  "foundations-theming-base": "/foundations-theming-base/static-1.3301",
  "HeadJS": "/HeadJS/static-2.735",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3026",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4227",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7827",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3511",
  "persist-promise": "/persist-promise/static-1.3612",
  "reporting-client-types": "/reporting-client-types/static-1.2427",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.753",
  "hs-story-utils": "/hs-story-utils/static-1.9333",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9736",
  "hubspotter-http": "/hubspotter-http/static-1.4574",
  "sassPrefix": "/sassPrefix/static-1.154",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7154",
  "crm-message-bus": "/crm-message-bus/static-1.42706",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21810",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12922",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13057",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9728",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3930",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6683",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6778",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3767",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.877",
  "onboarding-tours": "/onboarding-tours/static-1.16421",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13391",
  "ui-addon-teams": "/ui-addon-teams/static-1.21415",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68053",
  "customer-data-properties": "/customer-data-properties/static-1.51198",
  "forms-ai-lib": "/forms-ai-lib/static-1.4165",
  "forms-utils-lib": "/forms-utils-lib/static-1.12396",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5211",
  "react-dnd-compat": "/react-dnd-compat/static-1.4521",
  "react-tinymce": "/react-tinymce/static-1.54957",
  "tinymce-config": "/tinymce-config/static-2.54083",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10251",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3997",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1540",
  "ui-fonts": "/ui-fonts/static-1.620",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.819",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.508",
  "module-federation": "/module-federation/static-1.21",
  "quartz-head": "/quartz-head/static-1.538",
  "quartz-i18n": "/quartz-i18n/static-1.548",
  "quartz-routing": "/quartz-routing/static-1.303",
  "quartz-test": "/quartz-test/static-1.548",
  "quartz-tracking": "/quartz-tracking/static-1.252",
  "batch-promise": "/batch-promise/static-1.1455",
  "external-options-client-types": "/external-options-client-types/static-1.4080",
  "react-colorpicker": "/react-colorpicker/static-2.10112",
  "copilot-toolkit": "/copilot-toolkit/static-1.10852",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12616",
  "html-to-image": "/html-to-image/static-1.52",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-scopes": "/onboarding-scopes/static-1.6367",
  "reporting-action-components": "/reporting-action-components/static-1.40986",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1422",
  "reporting-plugins": "/reporting-plugins/static-1.10141",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4157",
  "ui-addon-opt": "/ui-addon-opt/static-4.8285",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10050",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.25068",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4781",
  "chirp-fetch": "/chirp-fetch/static-1.1784",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4089",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5690",
  "salesImages": "/salesImages/static-1.523",
  "ts-schema": "/ts-schema/static-1.4000",
  "nested-table": "/nested-table/static-1.129",
  "timezone-utils": "/timezone-utils/static-2.5147",
  "bender-build-tools": "/bender-build-tools/static-1.3063",
  "chatspot-core": "/chatspot-core/static-1.20824",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2799",
  "stylex": "/stylex/static-1.30",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9734",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3719",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4064",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3612",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18215",
  "growth-data-modal": "/growth-data-modal/static-1.5278",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2974",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1623",
  "navigation-components": "/navigation-components/static-1.17661",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4635",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.487",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7431",
  "ui-universal-auth": "/ui-universal-auth/static-1.8840",
  "user-context": "/user-context/static-1.5003",
  "cms-field-types": "/cms-field-types/static-1.4712",
  "content-icons-ui": "/content-icons-ui/static-1.2203",
  "integrations-lib": "/integrations-lib/static-1.15795",
  "calling-global-api": "/calling-global-api/static-1.64114",
  "calling-internal-common": "/calling-internal-common/static-1.31204",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65496",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57790",
  "commerce-products-lib": "/commerce-products-lib/static-1.9165",
  "crm-links": "/crm-links/static-1.6179",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9063",
  "file-manager-components": "/file-manager-components/static-1.23309",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.42",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4145",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.533",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48406",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3887",
  "property-value-citations": "/property-value-citations/static-1.1812",
  "pulse": "/pulse/static-1.447",
  "smart-property-lib": "/smart-property-lib/static-1.6458",
  "tiered-pricing": "/tiered-pricing/static-1.1017",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8953",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19661",
  "tinymce-themes": "/tinymce-themes/static-1.56053",
  "data-token-picker": "/data-token-picker/static-1.16232",
  "hub-http-contrib": "/hub-http-contrib/static-1.2946",
  "interframe": "/interframe/static-3.4666",
  "tinymce-data": "/tinymce-data/static-1.40168",
  "tinymce-plugins": "/tinymce-plugins/static-1.57197",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5114",
  "magpie-lib": "/magpie-lib/static-1.5496",
  "magpie-types": "/magpie-types/static-1.4956",
  "simple-logging-lib": "/simple-logging-lib/static-1.2954",
  "content-assistance-lib": "/content-assistance-lib/static-1.7608",
  "dashboard-lib": "/dashboard-lib/static-1.81113",
  "ExportDialog": "/ExportDialog/static-6.10293",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17951",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17943",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8598",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8654",
  "feedback-loader": "/feedback-loader/static-1.29113",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4554",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.240",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4404",
  "nav-client-types": "/nav-client-types/static-1.2261",
  "purchase-motions-api": "/purchase-motions-api/static-1.5693",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.76",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1796",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1651",
  "user-context-client": "/user-context-client/static-1.4515",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.125",
  "reactive-lib": "/reactive-lib/static-1.627",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.635",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17333",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13210",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5499",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7689",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10277",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.354",
  "calling-error-reporting": "/calling-error-reporting/static-1.31210",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10941",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6444",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.610",
  "customer-data-tracking": "/customer-data-tracking/static-1.6787",
  "commerce-permissions": "/commerce-permissions/static-1.668",
  "products-iframe-lib": "/products-iframe-lib/static-1.7650",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10118",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8928",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4056",
  "video-components-external": "/video-components-external/static-1.10956",
  "video-data-lib": "/video-data-lib/static-1.34614",
  "directed-graph": "/directed-graph/static-1.840",
  "event-emitter": "/event-emitter/static-1.851",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.42",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9819",
  "fsm": "/fsm/static-1.3637",
  "policy-lib": "/policy-lib/static-1.6687",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9882",
  "navigation-messaging": "/navigation-messaging/static-1.6988",
  "FileManagerLib": "/FileManagerLib/static-1.38949",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8990",
  "FileManagerCore": "/FileManagerCore/static-1.38808",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12256",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11231",
  "react-codemirror": "/react-codemirror/static-1.10527",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9790",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14802",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8599",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28264",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8448",
  "payment-link-components": "/payment-link-components/static-1.23252",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24158",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3086",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14536",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2910",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.28",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35387",
  "sales-views-client-types": "/sales-views-client-types/static-1.4166",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3532",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11923",
  "content-media-compositions": "/content-media-compositions/static-2.15930",
  "media-bridge-lib": "/media-bridge-lib/static-1.18752",
  "trellis-story-utils": "/trellis-story-utils/static-1.4422",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5770",
  "FileManagerImages": "/FileManagerImages/static-1.36460",
  "video-components": "/video-components/static-1.12959",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4435",
  "video-embed": "/video-embed/static-1.35448",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68128",
  "layout-data-lib": "/layout-data-lib/static-1.9556",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6485",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5914",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4989",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3569",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21501",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3746",
  "social-insights-client-types": "/social-insights-client-types/static-1.21790",
  "outpost": "/outpost/static-1.4097",
  "advanced-menus-core": "/advanced-menus-core/static-1.14977",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11939",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33770",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14976",
  "simple-menus-lib": "/simple-menus-lib/static-1.16493"
}
};
